import apiService from './api.service';
import {
  Service,
  ServiceCreationData,
  ServiceUpdateData,
  PaginatedServices,
  ServiceStatus,
} from '@/types/service.types';

interface GetServicesParams {
  page?: number;
  limit?: number;
  category?: string;
  status?: ServiceStatus;
}

class ServiceService {
  private readonly endpoint = '/services';

  async getServices(params: GetServicesParams = {}): Promise<PaginatedServices> {
    const { data } = await apiService.get(this.endpoint, { params });
    // The backend response might be wrapped, so we check for a 'data' property
    // and return it if it exists, otherwise return the data directly.
    return data.data || data;
  }

  async getGroupedActiveServices(): Promise<Record<string, Service[]>> {
    const response = await apiService.get(`${this.endpoint}/public/grouped`);
    // The actual grouped data is nested in the 'data' property of the response body
    return response.data.data;
  }

  async getServiceById(id: string): Promise<Service> {
    const { data } = await apiService.get(`${this.endpoint}/${id}`);
    return data.data;
  }

  async createService(serviceData: ServiceCreationData): Promise<Service> {
    const { data } = await apiService.post(this.endpoint, serviceData, {
      headers: {
        "Content-Type": 'multipart/form-data'
      }
    });
    return data.data;
  }

  async updateService(id: string, serviceData: ServiceUpdateData): Promise<Service> {
    const { data } = await apiService.put(`${this.endpoint}/${id}`, serviceData, {
      headers: {
        "Content-Type": 'multipart/form-data'
      }
    });
    return data.data;
  }

  async deleteService(id: string): Promise<void> {
    await apiService.delete(`${this.endpoint}/${id}`);
  }
}

export default new ServiceService();
